<mat-card *ngIf="hasData">
    <div class="chartjs-container">
        <h2 style="text-align: center;">Propuestas por categoria</h2>
        <canvas baseChart 
            [datasets]="chartData" 
            [labels]="tracks" 
            [options]="chartOptions"
            [plugins]="chartPlugins" 
            [legend]="chartLegend" 
            [chartType]="chartType">
        </canvas>
    </div>
</mat-card>

